import {
	Component,
	OnInit,
	ElementRef,
	Input,
	ViewChild,
	SimpleChanges,
	HostListener,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppServices } from "../../app.services";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { ApplicationModel } from "../../core/models/application.model";

@Component({
	selector: "app-playback-speed",
	templateUrl: "./playback-speed-controller.html",
	styleUrls: ["./playback-speed-controller.scss"],
})
export class PlayBackSpeedControllerDirective implements OnInit {
	@ViewChild("speedoptions") speedoptions: ElementRef;
	@ViewChild("speedButton", { static: true }) speedButton: ElementRef;

	@Input() mediaElement: any;
	@Input() showSpeedOption?: boolean;
	@Input() speed: boolean;
	public speedVariables: any[];
	public showSpeedDropDown: boolean = false;
	public selectedSpeed: any;
	public showTootip: boolean = false;
	constructor() {}

	ngOnInit() {}
	ngAfterViewInit() {
		this.configPlayerSpeed();
	}
	public ngOnChanges(changes: SimpleChanges) {
		if (
			changes.hasOwnProperty("speed") &&
			changes["speed"]["currentValue"] !== undefined
		) {
			this.configPlayerSpeed();
		}
	}

	private configPlayerSpeed() {
		this.speedVariables = UtilityScripts.getSpeedVariables();
		if (ApplicationModel.instance.playerSpeed) {
			this.mediaElement.playbackRate = ApplicationModel.instance.playerSpeed;
			this.mediaElement.defaultPlaybackRate =
				ApplicationModel.instance.playerSpeed;
			this.selectedSpeed = this.speedVariables.find(
				(item) => item.value == ApplicationModel.instance.playerSpeed
			);
			for (let item of this.speedVariables) {
				if (item.value == ApplicationModel.instance.playerSpeed) {
					item.selected = true;
				} else {
					item.selected = false;
				}
			}
		} else {
			this.selectedSpeed = this.speedVariables.find((item) => item.value == 1);
		}
	}
	public onSpeedSelected(value) {
		this.mediaElement.playbackRate = value;
		this.mediaElement.defaultPlaybackRate = value;
		ApplicationModel.instance.playerSpeed = value;
		this.selectedSpeed = this.speedVariables.find(
			(item) => item.value == ApplicationModel.instance.playerSpeed
		);
		this.showSpeedDropDown = false;
		for (let item of this.speedVariables) {
			if (item.value == ApplicationModel.instance.playerSpeed) {
				item.selected = true;
			} else {
				item.selected = false;
			}
		}
	}
	public toggleSpeed(event) {
		this.showSpeedDropDown = !this.showSpeedDropDown;
	}

	@HostListener("document:mousedown", ["$event"])
	onGlobalClick(event): void {
		if (
			event &&
			event.target &&
			event.target != this.speedoptions &&
			event.target != this.speedButton &&
			event.target.id != "speedBtn" &&
			!this.isDescendant(event.target, "speedoptions")
		) {
			this.showSpeedDropDown = false;
		}
	}
	private isDescendant = (el, parentId) => {
		let isChild = false;
		if (el.id === parentId) {
			//is this the element itself?
			isChild = true;
		}
		while ((el = el.parentNode)) {
			if (el.id == parentId) {
				isChild = true;
			}
		}
		return isChild;
	};

	public mouseover(event) {
		this.showTootip = UtilityScripts.isMobileDevice() ? false : true;
	}
	public mouseout(event) {
		this.showTootip = false;
	}
}
